module.exports = __webpack_public_path__ + "img/logo_circle_w150.661f0c92.png";